const isArray = (value) => Array.isArray(value);
export default isArray;
